import React from "react";
import PropTypes from "prop-types";

import Label from "../../label/Label";
import TooltipComponent from "../../../../ui/tooltip/TooltipComponent";

import "./Checkbox.scss";

const Checkbox = ({
  name = "",
  keyId,
  label = "",
  checked = false,
  onChange,
  isdisable = false,
  dataField,
  inputInfoConfig,
  ...fieldSetting
}) => {

  const handleCheckboxChange = (e) => {
    const newValue = e.target.checked;
    if (onChange) {
      onChange(dataField, newValue);
    }
  };

  return (
    <div className="checkbox-part">
      <div className="checkbox">
        <input
          id={name}
          key={keyId}
          name={name}
          className="form-checkbox"
          type="checkbox"
          checked={checked}
          onChange={handleCheckboxChange}
          disabled={isdisable}
          {...fieldSetting}
        />
        <label
          htmlFor={name}
          className={`checkbox-label ${isdisable ? "checkbox-disabled" : ""}`}
        >{" "}</label>
      </div>
      {label && <Label labelName={label} htmlFor={name} />}
      {inputInfoConfig?.isInfoIcon && (
        <TooltipComponent
          iconName={inputInfoConfig?.iconName}
          message={inputInfoConfig?.message}
        />
      )}
    </div>
  );
};

Checkbox.propTypes = {
  name: PropTypes.string,
  keyId: PropTypes.string,
  label: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  isdisable: PropTypes.bool,
  dataField: PropTypes.string,
  inputInfoConfig: PropTypes.shape({
    isInfoIcon: PropTypes.bool,
    iconName: PropTypes.string,
    message: PropTypes.string,
  }),
  fieldSetting: PropTypes.object,
};

Checkbox.defaultProps = {
  name: "",
  label: "",
  checked: false,
  isdisable: false,
  dataField: "",
};

export default Checkbox;
